<template>
  <div class="p-md flex flex-col">
    <div class="flex gap-sm items-center grow">
      <div class="flex flex-col">
        <or-skeleton-rect
          :width="width"
          :height="height"
        />
        <or-skeleton-rect
          :width="width"
          :height="height"
        />
      </div>
      <div class="flex flex-col gap-sm grow">
        <or-skeleton-rect :height="height" />
        <or-skeleton-rect :height="height" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrSkeletonRectV3 as OrSkeletonRect } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'BaseVirtualScrollItemPlaceholder',

  components: {
    OrSkeletonRect,
  },

  props: {
    height: {
      type: Number,
      default: 36,
    },
    width: {
      type: Number,
      default: 100,
    },
  },
});
</script>
